import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import CustomOptionsUI from './custom-options-ui'

const CustomOptions = () => {
	const productContextValue = useProductContext()

	if (!productContextValue) {
		return null
	}

	const [
		{
			product: { customOptions },
		},
		{ resetCustomOptions },
	] = productContextValue

	return <CustomOptionsUI customOptions={customOptions} resetCustomOptions={resetCustomOptions} />
}

export default CustomOptions
